<template>
  <div>
    <v-row>
      <v-col cols="12">
        <input type="text"
          v-model=title
          style="width:100%;padding: 2px 10px;font-size:15pt;border-bottom: 1px solid #ddd"
        >
        <p style="margin-top:6px;margin-bottom:0;">
          <v-btn small outlined style="margin:0px 9px;" color="pink" @click="changeTitle('お買い物リスト')">お買い物リスト</v-btn>
          <v-btn small outlined style="" color="pink" @click="changeTitle('ToDoリスト')">ToDoリスト</v-btn>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
      <draggable tag="ul" id="todolist" :options="{handle: '.item-handle'}">
        <li v-for="(t, index) in todos" :key=t.key :id=t.key>
        <v-card
          flat
          class="todoContent"
          v-show="t.isVisible"
          style="border-bottom: solid 1px #ddd"
          tile
        >
          <textarea
            :placeholder="placeHolder(index)"
            v-show="t.isEditMode"
            v-model="todos[index].t"
            outlined
            rows="1"
            style="width:100%;padding:8px 10px;resize: none;overflow-y:visible;"
            @keyup="onInputText(t.key)"
            @focus="onFocus(t.key)"
            @focusout="onFocusout(t.key)"
            :ref="t.key"
          ></textarea>
          <v-list v-show="!t.isEditMode">
            <v-list-item>
              <v-list-item-icon class="item-handle">
                <v-icon>mdi-drag</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  @click="onReEdit(t.key)"
                >
                  {{t.t}}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-btn icon small
                  @click="onDelete(t.key)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card>
        </li>
      </draggable>
      </v-col>
    </v-row>
    <div style="height:64px;"></div>
    <v-card flat tile style="position:fixed; bottom:0;left:0;width:100%;border-top:1px solid #ccc;">
      <v-row style="padding:10px;">
        <v-spacer></v-spacer>
          <v-btn color="pink" dark large @click="onSave">
            <span v-show="!isLoading">保存する</span>
            <v-progress-circular
                v-show="isLoading"
                indeterminate
                color="white"
              ></v-progress-circular>
          </v-btn>
          <v-btn color="grey" outlined dark large @click="onClear" style="margin-left:16px;">
            クリア
          </v-btn>
        <v-spacer></v-spacer>
      </v-row>
    </v-card>
    <notifications group="bottomNotifer"
                   :duration="3000"
                   :width="200"
                   position="top right">
      <template slot="body" slot-scope="props">
        <div class="custom-template"
          @click="onRecovery(props.item.data.key)"
          :ref="`notification_${props.item.data.key}`"
        >
          <div class="custom-template-icon">
            <i class="icon ion-android-checkmark-circle"></i>
          </div>
          <div class="custom-template-content">
            <div class="custom-template-title">
              {{props.item.title}}
            </div>
            <div class="custom-template-text">
              <v-icon>mdi-reply</v-icon>元に戻す
            </div>
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import { db } from '@/main'
import draggable from 'vuedraggable'

// @ is an alias to /src
export default {
  name: 'EditTodo',
  data () {
    return {
      isLoading: false,
      todos: [],
      iUsed: 0,
      imax: 10,
      iNokori: 3,
      today: '',
      title: ''
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.user.isLogin
    },
    uid () {
      return this.$store.state.user.uid
    },
    displayName () {
      return this.$store.state.user.displayName
    }
  },
  components: {
    draggable
  },
  created () {
    this.todos = this.$store.state.todo.todos
    this.init()
  },
  methods: {
    async init () {
      // vuexの値を引き継ぐ
      this.getValFromVuex()

      // 必要な変数の初期化
      let date = new Date()
      var month = date.getMonth() + 1
      var week = date.getDay()
      var day = date.getDate()
      var yobi= new Array('日', '月', '火', '水', '木', '金', '土')
      this.today = `${month}月${day}日（${yobi[week]}）`

      // Vuexの値が存在しない場合 => 編集ページの初期化
      if (!this.isBackupExist()) {
        this.$store.commit('todo/clear')
        this.initEditArea()
      } else {
        this.$emit('onMessage', {
          text: '作成中のリストが存在します。<br>新規で作成する場合は、クリアをタップしてください。',
          title: 'Information',
          type: 'success'
        })
      }

      //匿名認証
      if (!this.isLogin) await this.$store.dispatch('user/loginAnonymous')
    },
    isBackupExist () {
      let flag = false
      for (let i = 0; i < this.todos.length; i++) {
        if (this.todos[i].t !== '' && this.todos[i].isVisible) {
          flag = true
          break
        }
      }
      return flag
    },
    initEditArea () {
      this.title = `無題のリスト ${this.today}`
      for (let i = 0; i < this.imax; i++) {
        this.addListObj()
      }
    },
    changeTitle (text) {
      this.title = `${text} ${this.today}`
    },
    placeHolder (index) {
      if (index === 0) {
        return '1つ目の項目を書いてみよう'
      } else if (index === 1) {
        return '改行で次の行に移動します'
      }
    },
    onInputText (key) {
      let index = this.getTodoIndexByKey(key)
      if (this.todos[index].t.indexOf('\n') >= 0) {
        // 改行を検知

        // 改行を消す
        let text = this.todos[index].t.replace(/\n/g, '')
        this.todos[index].t = text
        // 改行のみしか入力がなければ何もしない
        if (text === '') return

        let obj = this.todos[index]
        // 入力済に更新
        obj.isEditMode = false
        obj.isInputed = true

        // obj.t = text
        this.todos.splice(index, 1, obj)
        
        // フォーカスを次の行へ
        let nextTodo = this.getNextTodoByKey(key)
        let refName = nextTodo.key
        
        this.$refs[refName][0].focus()

        if (!this.isNokoriAru()) {
          this.addListObj()
        }

        // vuexにバックアップ
        this.setValToVuex()
      }
    },
    onFocus (key) {
      let index = this.getTodoIndexByKey(key)
      // if (index > 0) return
      // 対象が入力アリの場合、何もしない
      if (this.todos[index].t.length > 0) {
        return
      }
      // 対象が未入力の場合
      // indexより前に未入力のカラムがないかチェックする
      for (let i = 0; i <= index; i ++) {
        if (this.todos[i].isVisible && this.todos[i].t.length === 0) {
          let refName = this.todos[i].key
          this.$refs[refName][0].focus()
          return
        }
      }
    },
    onFocusout (key) {
      let index = this.getTodoIndexByKey(key)
      let isUpdate = false
      if (this.todos[index].isInputed) {
        if (this.todos[index].t.length > 0) {
          this.todos[index].isEditMode = false
          isUpdate = true
        } else {
          this.todos[index].isVisible = false
          isUpdate = true
        }
      } else {
        if (this.todos[index].t.length > 0) {
          this.todos[index].isInputed = true
          this.todos[index].isEditMode = false
          isUpdate = true
        }
      }

      if (isUpdate) {
        // vuexにバックアップ
        this.setValToVuex()
      }
    },
    onReEdit (key) {
      let index = this.getTodoIndexByKey(key)
      this.todos[index].isEditMode = true
      let refName = key
      // console.log(this.$refs[refName][0])
      setTimeout(
        function() {
          this.$refs[refName][0].focus()
        }.bind(this),
        100
      );
    },
    onDelete (key) {
      let index = this.getTodoIndexByKey(key)
      this.todos[index].isVisible = false
      this.$notify({
        group: 'bottomNotifer',
        title: '削除しました',
        text: '削除しました',
        type: 'information',
        data: {
          t: this.todos[index].t,
          key: key
        }
      })
      if (!this.isNokoriAru()) {
        this.addListObj()
      }
      // vuexにバックアップ
      this.setValToVuex()
    },
    onRecovery (key) {
      let index = this.getTodoIndexByKey(key)
      this.todos[index].isVisible = true
      this.$refs[`notification_${key}`].style.display = 'none'
      // vuexにバックアップ
      this.setValToVuex()
    },
    async onSave () {
      if (this.isLoading) return
      // vuexにバックアップ
      this.setValToVuex()

      this.isLoading = true

      let ul = document.getElementById('todolist')
      let lis = ul.children
      let todos = {}
      let displayNum = 0
      for (let i = 0; i < lis.length; i++) {
        let isAdd = false
        let key = lis[i].id
        let obj = this.todos.find(t => t.key === key)
        if (obj.isInputed && obj.isVisible) {
          isAdd = true
        } else if (obj.isVisible && obj.t.length > 0) {
          isAdd = true
        }

        if (isAdd) {
          delete obj.key
          obj.displayNum = displayNum
          todos[key] = obj
          displayNum++
        }
      }

      if (Object.keys(todos).length === 0) {
          this.$emit('onMessage', {
            text: 'リストが未入力です',
            title: 'エラー',
            type: 'error'
          })
        this.isLoading = false
        return
      }

      let todosObj = this.getTodoObj(todos)
      let result = await db.collection('todos').add(todosObj)
      this.isLoading = false
      this.$emit('onMessage', {
        text: 'Todoリストを登録しました'
      })
      this.id = result.id
      // 更新成功したのでvuexのバックアップをクリア
      this.$store.commit('todo/clear')
      this.$router.push({name: 'TodoView', params: {id: this.id}})
    },
    onClear () {
      if (window.confirm('入力内容をクリアします。\nよろしいですか？')) {
        this.$store.commit('todo/clear')
        this.init()
        this.$emit('onMessage', {
          text: '入力内容をクリアしました'
        })
      }
    },
    isNokoriAru () {
      let nokori = 0
      for (let i = 0; i < this.todos.length; i++) {
        if (this.todos[i].t === '') {
          nokori = nokori + 1
          if (nokori >= this.iNokori) {
            return true
          }
        }
      }
      return false
    },
    addListObj () {
      let now = new Date()
      let time = now.getTime()
      this.todos.push({
        t: '',
        isEditMode: true, // trueでテキスト編集モード
        isInputed: false, // 最初に入力されたらTrue
        isVisible: true,
        isDone: false,
        uid: this.uid,
        key: `col_${time}_${this.iUsed}`
      })
      this.iUsed = this.iUsed + 1
    },
    getTodoObj (todos) {
      let timestamp = new Date()
      let obj = {
        todos: todos,
        metas: {
          author: this.uid,
          createdAt: timestamp,
          title: this.title,
          displayNames: [
            {
              uid: this.uid,
              displayName: this.displayName
            }
          ]
        },
        members: [this.uid]
      }
      return obj
    },
    getTodoByKey (key) {
      return this.todos.find(t => t.key === key)
    },
    getTodoIndexByKey (key) {
      return this.todos.findIndex(t => t.key === key)
    },
    getNextTodoByKey (key) {
      let index = this.todos.findIndex(t => t.key === key)
      return this.todos[index + 1]
    },
    // vuexのバックアップを取得
    getValFromVuex () {
      this.title = this.$store.state.todo.title
      this.todos = this.$store.state.todo.todos
    },
    // vuexへ作成中のデータを渡す
    setValToVuex () {
      this.$store.commit('todo/setTitle', this.title)
      this.$store.commit('todo/setTodos', this.todos)
    },
  },
  head: {
    meta: [
      {name: 'robots', content: 'noindex'}
    ]
  }
}
</script>
<style scoped>
  .todoContent >>> .v-list {
    padding: 0 !important;
  }
  .todoContent >>> .v-list-item {
    padding: 0 !important;
    height: 48px;
  }
  .todoContent >>> .v-list-item__content {
    padding: 8px 0 !important;
  }
  .todoContent >>> .v-list-item__icon {
    margin-right: 16px;
    margin-top: 12px;
  }
  .custom-template {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    text-align: left;
    font-size: 13px;
    margin: 5px;
    margin-bottom: 0;
    align-items: center;
    justify-content: center;
    background: #333;
    border: 2px solid #000;
  }
  .custom-template-icon {
    flex: 0 1 auto;
    color: #fff;
    font-size: 32px;
    padding: 0 10px;
  }
  .custom-template-close {
    flex: 0 1 auto;
    padding: 0 20px;
    font-size: 16px;
    opacity: 0.2;
    cursor: pointer;
  }
  .custom-template-close:hover {
    opacity: 0.8;
  }
  .custom-template-close:click {
    opacity: 0.8;
  }
  .custom-template-content {
    padding: 5px;
    flex: 1 0 auto;
    color: #fff;
    font-size: 12pt
  }
  .custom-template-title {
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 600;
    color: #fff;
  }
  .custom-template-content .v-icon {
    color: #fff;
    margin-right:10px;
  }
  .custom-template-text {
    margin-top:4px;
  }
  .isDone {
    background-color: #ddd;
  }

</style>